export type { TransProps } from './Trans';

export { default as Trans } from './Trans';
